import { ComponentPropsWithoutRef, createContext, useContext } from 'react';

import { GeneratedFile } from '@Models';
import { resolveFileMarker } from '../../../Helpers/Agents/fileMarkers';
import ImageAttachment from './ImageAttachment';

export interface InlineImageContextValue {
  generatedFiles?: GeneratedFile[];
  conversationId?: string;
  timestamp?: string;
  onExpand?: (file: GeneratedFile, url: string) => void;
}

// Per-message data reaches the module-scoped `img` override through context so its identity stays stable.
export const InlineImageContext = createContext<InlineImageContextValue>({});

// react-markdown `img` override: a `file:` marker becomes the ImageAttachment card; anything else renders nothing.
const InlineMarkdownImage = ({ src }: ComponentPropsWithoutRef<'img'>) => {
  const { generatedFiles, conversationId, timestamp, onExpand } = useContext(InlineImageContext);
  const file = resolveFileMarker(src, generatedFiles);
  if (!file || !conversationId || !timestamp || !onExpand) return null;
  return <ImageAttachment file={file} conversationId={conversationId} timestamp={timestamp} onExpand={onExpand} />;
};

export default InlineMarkdownImage;
